// Instala el shim del modo demo: intercepta window.fetch (todo /api/*) para que TODA la
// actividad de red se resuelva local, sin tocar el backend. Idempotente.
//
// Ya no hay shim de WebSocket: con el rail v2 el POS confirma el cobro por polling de
// GET /api/v2/invoices/{id}. El `/ws/payments` real solo lo alimenta v1 y NO esta scopeado
// por tenant, asi que reusarlo habria filtrado pagos entre comercios.

import { handleApi } from "./backend";

let installed = false;

function urlPath(input: RequestInfo | URL): string {
  const raw =
    typeof input === "string"
      ? input
      : input instanceof URL
        ? input.toString()
        : input.url;
  try {
    // rutas relativas ("/api/…") o absolutas: normalizamos a pathname+search
    const u = new URL(raw, window.location.origin);
    return u.pathname + u.search;
  } catch {
    return raw;
  }
}

function jsonResponse(status: number, body: unknown): Response {
  if (status === 204 || body === undefined) {
    return new Response(null, { status });
  }
  return new Response(JSON.stringify(body), {
    status,
    headers: { "Content-Type": "application/json" },
  });
}

function safeParseBody(body: BodyInit | null | undefined): unknown {
  if (typeof body !== "string") return undefined;
  try {
    return JSON.parse(body);
  } catch {
    return undefined;
  }
}

function methodOf(input: RequestInfo | URL, init?: RequestInit): string {
  if (init?.method) return init.method;
  if (typeof input !== "string" && !(input instanceof URL)) return input.method;
  return "GET";
}

export function installDemoBackend(): void {
  if (installed || typeof window === "undefined") return;
  installed = true;

  // --- fetch shim: intercepta /api/*, deja pasar lo demás (assets, etc.) ---
  const origFetch = window.fetch.bind(window);
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const path = urlPath(input);
    if (path.startsWith("/api/")) {
      const method = methodOf(input, init);
      const body =
        init?.body !== undefined
          ? safeParseBody(init.body)
          : undefined;
      const { status, body: resBody } = handleApi(method, path, body);
      return jsonResponse(status, resBody);
    }
    return origFetch(input, init);
  };

}
